import { Avatar, AvatarGroup, AvatarSize } from '@myn/mui';

import { useAgencyClients } from '../../../api/queries/agencyClients.js';
import { UserType } from '../../../api/users/index.js';

export type Props = UserType & {
  onClick: (user: UserType) => void;
};

const ClientsCell = ({ onClick, ...value }: Props) => {
  const { agencyClients } = useAgencyClients();

  const clients =
    value?.assignedClients?.map((assignedClient) => {
      return agencyClients?.find((client) => client.id === assignedClient);
    }) || [];

  return (
    <div className="z-[1] flex gap-2 whitespace-nowrap">
      <AvatarGroup
        max={4}
        size={AvatarSize.small}
        bgColor="primary"
        onClick={() => onClick(value)}
      >
        {clients.map((client) => (
          <Avatar
            firstName={client?.name}
            key={client?.id}
            src={client?.logo}
          />
        ))}
      </AvatarGroup>
    </div>
  );
};

export default ClientsCell;
